<div class="close-icon" mat-button (click)="onClose()"></div>
<div>
  <h2 mat-dialog-title style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Sign</h2>
  <mat-dialog-content [formGroup]="form">
    <div>
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput type="url" formControlName="name" style="width: 200px;" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field style="margin-right: 5px">
        <mat-label>Date</mat-label>
        <input
          matInput
          [matDatepicker]="picker1"
          formControlName="date"
          required
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker1"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="sign()" style="border-radius: 6px;">Sign
    </button>
    <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
  </mat-dialog-actions>
</div>
